<script>
  import { SPRITESHEET_URL } from '../../utils/constants';
  import BaseSpinner from '../BaseSpinner/BaseSpinner.svelte';
  import BaseDiv from '../BaseDiv/BaseDiv.svelte';
  import BaseButton from '../BaseButton/BaseButton.svelte';

  let {
    initialLoadingText,
    failureText,
    successText,
    progressTemplate,
    retryAction = () => {},
    totalCount = 0,
    currentCount = 0,
    success = false,
    failure = false,
    loadingDone = false,
    dataTestId = 'loading-pricing-skeleton-tile',
  } = $props();

  let progressBarWidth = $state(0);
  $effect(() => {
    if (loadingDone) {
      progressBarWidth = 100;
    } else if (totalCount) {
      progressBarWidth = (currentCount * 100) / totalCount;
    }
  });

  let progressText = $derived(progressTemplate.replace(/{{CURRENT}}/, currentCount).replace(/{{TOTAL}}/, totalCount));
  let componentAttrs = $derived(
    failure
      ? {
          className:
            'w-full my-4 flex h-18 sm:h-22 rounded-lg shadow-y-sm border border-gray-light-silver relative active:shadow-active pseudo-shadow-hover',
          onClick: retryAction,
        }
      : {
          className:
            'w-full my-4 flex h-18 sm:h-22 rounded-lg shadow-y-sm border border-gray-light-silver overflow-hidden',
        }
  );

  const SvelteComponent = $derived(failure ? BaseButton : BaseDiv);
</script>

<div aria-live="assertive" aria-label={progressText} data-testid="{dataTestId}-progress"></div>
<SvelteComponent {...componentAttrs} {dataTestId}>
  <div class="h-full flex-auto flex items-center px-4 py-3 border-r border-gray-light-silver bg-white">
    {#if success}
      <svg
        class="flex-none w-3.5 h-3.5 sm:w-5.5 sm:h-5.5 fill-current text-blue-cerulean"
        role="presentation"
        data-testid="loading-pricing-skeleton-tile-check"
      >
        <use xlink:href="{SPRITESHEET_URL}#check" />
      </svg>
    {:else if failure}
      <svg
        class="flex-none w-3.5 h-3.5 sm:w-5.5 sm:h-5.5 fill-current text-red"
        role="presentation"
        data-testid="loading-pricing-skeleton-tile-alert"
      >
        <use xlink:href="{SPRITESHEET_URL}#alert" />
      </svg>
    {:else}     
      <BaseSpinner
        className="w-4 h-4 sm:w-6 sm:h-6 text-blue-cerulean"
        dataTestId="loading-pricing-skeleton-tile-spinner"
      />
    {/if}
    <div class="ml-2 sm:ml-4 w-full">
      <p class="leading-tight text-xs sm:text-base text-left">
        {#if success}
          {successText}
        {:else if failure}
          <!-- prettier-ignore -->
          {failureText}
        {:else if totalCount > 0}
          <!-- prettier-ignore -->
          {progressText}
        {:else}
          <!-- prettier-ignore -->
          {initialLoadingText}
        {/if}
      </p>
      <div class="w-full h-1 sm:h-2 mt-1 sm:mt-2 rounded-lg overflow-hidden border border-gray-light-silver">
        <div
          class="h-full rounded-lg shadow-y-sm transition-all ease-in duration-200"
          class:bg-blue-cerulean={!success && !failure}
          class:bg-green-success={success && !failure}
          class:bg-red-error={!success && failure}
          style="width: {progressBarWidth}%;"
          data-testid="loading-pricing-skeleton-tile-progress-bar"
        ></div>
      </div>
    </div>
  </div>
  <div class="flex grow-0 flex-row w-30 sm:w-36 md:w-46 lg:w-53 min-h-full items-center px-1 py-4">
    <div class="flex-auto flex flex-col items-center justify-center pl-3 px-2">
      <div class="w-20 h-4 sm:w-24 sm:h-6 skeleton-gradient animated-skeleton"></div>
      <div class="w-12 mt-2 sm:w-16 h-2 sm:h-4 skeleton-gradient animated-skeleton animation-delay-75"></div>
    </div>
    <svg class="flex-none w-4 h-4 lg:w-6 lg:h-6 fill-current text-gray-silver" role="presentation">
      <use xlink:href="{SPRITESHEET_URL}#chevron-right" />
    </svg>
  </div>
</SvelteComponent>
